import React from 'react'
import ConfirmationButton from '../ConfirmationButton';
import styles from './styles.module.css'

export default function ConfirmModal({confirmText,rejectText,confirmFunction,rejectFunction,text}) {

  return (
    <>
    <p className={styles.text}>
    {text}
  </p>
<ConfirmationButton                       
confirmText={confirmText}
    rejectText={rejectText}
    confirmFunction={(e) => {
      confirmFunction(e)
    }}
    rejectFunction={() => {
      rejectFunction()
    }}/>
    </>
  )
}
